import { render, staticRenderFns } from "./WordleCTA.vue?vue&type=template&id=000beebd&scoped=true"
import script from "./WordleCTA.vue?vue&type=script&lang=js"
export * from "./WordleCTA.vue?vue&type=script&lang=js"
import style0 from "./WordleCTA.vue?vue&type=style&index=0&id=000beebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000beebd",
  null
  
)

export default component.exports